<template>
  <!-- <input :type="type" :value="value" :disabled="disabled" :class="priority"> -->
  <button
    :value="value"
    v-bind="$attrs"
    :disabled="disabled || isLoading"
    :class="[priority, { hasIcon }]"
    :type="type"
  >
      <div v-if="isLoading" class="lds-ring"><div></div><div></div><div></div><div></div></div>
      <span :style="{ opacity: isLoading? 0: 1 }">
          <slot/>
          {{ value }}
      </span>
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    type: {
      type: String,
      default: "button",
      validator(val: string) {
        return ["submit", "button", "reset"].includes(val);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
    },
    priority: {
      type: String,
      default: "ghost",
      validator(val: string) {
        return ["primary", "outline", "ghost"].includes(val);
      },
    },
  },
  computed: {
    hasIcon() {
      return !!this.$slots.default;
    },
  },
});
</script>

<style lang="scss" scoped>
$color-button-primary-active-bg: #002C7C;
$color-button-primary-disabled-bg: #cfcfd1;
$color-button-primary-focus-bg: #00469B;
$color-button-primary-focus-active-outline: #9B89D0;
$color-button-primary-disabled-text: #727272;
$color-button-secondary-hover-bg: #014698;
$color-button-secondary-active-bg: #083872;
$color-button-ghost-disabled-outline: #979797;

input[type="submit"],
input[type="button"],
button {
  padding: 16px 40px;
  white-space: normal;
  text-align: center;
  font-weight: 600;
  font-size: inherit;
  cursor: pointer;
  border: none;
  line-height: 1;
  transition: all 0.15s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    cursor: not-allowed;
    text-shadow: none;
    color: $color-button-primary-disabled-text;
    background-color: $color-button-primary-disabled-bg;
  }

  &.hasIcon {
    padding: 12px 40px;
    min-height: 48px;
    // white-space: nowrap;
  }
}

img,
svg {
  min-width: 24px;
  max-height: 24px;
  max-width: 24px;
  margin-right: 16px;
  color: inherit;
  fill: currentColor;
}

.primary {
  color: #fff;
  background-color: $color-primary-blue;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.4);

  &:not(:disabled):hover {
    background-color: #065BC2;
    box-shadow: $ui-shadow;
  }

  &:not(:disabled):focus {
    outline: 2px solid $color-button-primary-focus-active-outline;
  }

  &:not(:disabled):active {
    background-color: $color-secondary-darkblue;
    outline: 2px solid $color-button-primary-focus-active-outline;
  }
}

.outline {
  outline: 1px solid $color-primary-blue;
  color: $color-primary-blue;
  background-color: transparent;

  &:not(:disabled):hover {
    box-shadow: $ui-shadow;
    color: #fff;
    background-color: $color-primary-blue;
  }

  &:not(:disabled):focus {
    color: #fff;
    background-color: $color-primary-blue;
    outline: 2px solid $color-button-primary-focus-active-outline;
  }

  &:not(:disabled):active {
    color: #fff;
    background-color: $color-secondary-darkblue;
    outline: 2px solid $color-button-primary-focus-active-outline;
  }
}

.ghost {
  outline: 1px solid #fff;
  color: #fff;
  background-color: transparent;

  &:not(:disabled):hover {
    box-shadow: $ui-shadow;
    color: $color-primary-blue;
    background-color: #fff;
  }

  &:not(:disabled):focus {
    color: $color-primary-blue;
    background-color: #fff;
    outline: 2px solid #9f9f9f;
  }

  &:not(:disabled):active {
    color: $color-primary-blue;
    background-color: #f4f4f4;
    outline: 2px solid #9f9f9f;
  }
}

//loading indicator:
.lds-ring {
    display: inline-block;
    position: relative;
    width: 16px;
    height: 16px;
    position: absolute;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 12px;
    height: 12px;
    margin: 2px;
    border: 2px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
